<div class="chat-item" routerLink="/messenger/{{ conversation.uniqueName }}">
  <app-user-avatar [size]="48" [user]="mainParticipantUser" [preventClick]="true"></app-user-avatar>
  <div class="chat-item_info">
    <div class="chat-item_info-nickname">
      <span class="title">{{ mainParticipantUser?.userName || '...' }}</span>
      <div *ngIf="mainParticipantUser?.isOnline" class="user-online_point"></div>
    </div>
    <span 
      *ngIf="getConversationUnreadCount(conversation)" 
      class="p6 grey-text"
    >{{ conversation.lastMessageBody || '...' }}</span>
    <span 
      *ngIf="!getConversationUnreadCount(conversation)" 
      class="p6 grey-text"
    >{{ conversation.lastMessageDateCreated | creationDate }}</span>
  </div> 

  <span class="p6 chat-item_counter" *ngIf="getConversationUnreadCount(conversation) as unreadCount">
    {{  unreadCount | formattedCount:99 }}
  </span>
</div>